namespace Matrix.Data {
    export interface RelationshipTypeRow {
        RelationshipTypeCode?: string;
        Name?: string;
        RelationshipGroup?: string;
        Status?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace RelationshipTypeRow {
        export const idProperty = 'RelationshipTypeCode';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Data.RelationshipType';
        export const lookupKey = 'Data.RelationshipType';

        export function getLookup(): Q.Lookup<RelationshipTypeRow> {
            return Q.getLookup<RelationshipTypeRow>('Data.RelationshipType');
        }
        export const deletePermission = 'DataAdmin:RelationshipType';
        export const insertPermission = 'DataAdmin:RelationshipType';
        export const readPermission = 'Read:RelationshipType';
        export const updatePermission = 'DataAdmin:RelationshipType';

        export declare const enum Fields {
            RelationshipTypeCode = "RelationshipTypeCode",
            Name = "Name",
            RelationshipGroup = "RelationshipGroup",
            Status = "Status",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
